const tagMappings = {
  // "Initiative Management": 2164,
  "Initiative Management": 2173,
  Initiative: 2182,
  "Converted Initiatives": 2318,
  "Completed Initiatives": 2333,
  "Withdrawn Initiatives": 2315,
  Warehouse: 2322,
  "Action Items": 2270,
  "Watch List Configuration": 2309,
  "External Audit": 2284,
  "Initiative Reallocation": 2302,
  "Initiative Activate - Snooze": 2306,
  "Initiative Status Management": 2334,
  "Initiative Tracking": 2291,
  "Initiative Progress": 2239,
  "Initiative Conversion": 2213,
  "Initiative Prioritization": 2236,
  "Initiative Linking": 2274,
  "Initiative Search": 2341,
  "Man-Com Prioritization": 2344,
  Program: 2216,
  "Program List": 2219,
  "Projects List": 2215,
  "Milestone Progress": 2231,
  "Update Project Health": 2243,
  "Project Health Sheet Approval": 2240,
  "Update Actual Cost": 2258,
  Configuration: 1,
  "Company Information": 1029,
  "Corporate Settings": 1030,
  EmailMessages: 456,
  "Framework Email Messages": 1614,
  Security: 442,
  "User Maintenance": 23,
  "Vendor Login Maintenance": 1031,
  "User Login Maintenance": 1009,
  "Active Session Maintenance": 1891,
  "Role Maintenance": 53,
  "Node Maintenance": 1890,
  "Role Access": 312,
  "User Group Access": 1007,
  "User Groups": 1008,
  "Unlock User": 22199,
  "Password Management": 1969,
  Projects: 2262,
  "Project Status": 2261,
  Practice: 2267,
  "Project Group": 2029,
  "Project Type": 2263,
  "Project Size Units": 2264,
  "Initiative Masters": 2180,
  "Nature of Initiative": 2114,
  "Initiative Stage": 2113,
  "Initiative Category": 2106,
  Vendor: 2224,
  Priority: 2108,
  "Resource Approach": 2110,
  "Initiative Access": 2168,
  "Cost Category": 2190,
  "Initiative SQERT Ranges": 2217,
  "Action Status": 2268,
  "Action Priority": 2269,
  "Initiative Relation Type Master": 2276,
  "Initiative Corporate Fields": 2282,
  Checklist: 2166,
  "Checklist Maker Inbox": 2277,
  "Checklist Section": 2167,
  "Checklist Item": 2170,
  "Prioritization Checklist": 2172,
  "Checklist Maker": 2275,
  "Business Masters": 2179,
  "Process Information": 1598,
  "Business Strategy": 2175,
  "Business  Feasibility": 2178,
  "Business  Impact": 2177,
  "Business Value": 2176,
  "Risk Master": 2186,
  "Risk Categories": 2160,
  "Risk Matrix Definition": 2212,
  CustomReportWriter: 544,
  "Report Builder": 545,
  "Report Security": 1832,
  "Custom Report Access": 1807,
  "Query Builder": 585,
  "Entity Access": 586,
  "Cross Tab Query": 1562,
  "Query Maintenance": 588,
  "Connection Master": 801,
  EntityUpdateSchedule: 913,
  "Group Master": 1605,
  QueryBuilder: 587,
  Variables: 1560,
  Reports: 806,
  "Log Report": 807,
  "User Access Report": 808,
  Organization: 2233,
  "Organization Structure": 2184,
  "Business Group": 1265,
  "Organization Unit": 395,
  "Delivery Unit": 2015,
  "Delivery Team": 1266,
  "Department Master": 396,
  "General Information": 2254,
  Currency: 2035,
  Skills: 2255,
  "Audit Type Definition": 2279,
  "Documents Category": 2310,
  Country: 2340,
  // Added by Gauri on 19 Nov 2024 for Initiative Dashboard
  "Initiative Dashboard": 22205,
};

export default tagMappings;
